import { render, staticRenderFns } from "./FInfoINRCompare.vue?vue&type=template&id=27170dbf&"
import script from "./FInfoINRCompare.vue?vue&type=script&lang=ts&"
export * from "./FInfoINRCompare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports